import React, { Component } from "react";
import _ from "lodash";
// import axios from "axios";
import matchSorter from "match-sorter";

//React Tabs
import Tabs from "react-responsive-tabs";
import "react-responsive-tabs/styles.css";

//React Table
import ReactTable from "react-table";
import "react-table/react-table.css";

import { Tips } from "./Utils";

//Data
import SampleData from "./data/jsonExport.json";
import Companion from "./data/Companion-USA.json";
import Farm from "./data/Farm-USA.json";
import Animal from "./data/Animal-Health-Canada.json";
import ProBeautyCan from "./data/Pro-Beauty-Canada.json";
import ProBeautyUs from "./data/Pro-Beauty-USA.json";
import Cannabis from "./data/Cannabis-Canada.json";
import PeroxUS from "./data/LAR-USA.json";

// let getParamValue = function(paramName) {
//   var url = window.location.search.substring(1); //get rid of "?" in querystring
//   var qArray = url.split("&"); //get key-value pairs
//   for (var i = 0; i < qArray.length; i++) {
//     var pArr = qArray[i].split("="); //split key and value
//     if (pArr[0] === paramName) console.log(pArr[1]);
//     return pArr[1]; //return value
//   }
// };

class App extends Component {
  constructor() {
    super();
    this.state = {
      data: [],
      loading: true
    };
  }

  componentDidMount() {
    this.setState({
      loading: true
    });

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const urlQS = urlParams.get('url')

    console.log(urlQS);

    // var urlParam = getParamValue("url");

    // var url =
    //   window.location !== window.parent.location
    //     ? urlParam
    //     : document.location.href;

    // console.log('Window Location', window.location);
    // console.log('Window Parent', window.parent.location);
    // console.log('ParamValue', urlParam);
    // console.log('Document Location', document.location.href)

    var url = urlQS;

    let AppData = SampleData;
    //css class names found in index.css
    let colours = ["red", "blue", "green"];
    switch (url) {
      case "https://learnaboutrescue.com/resources":
        AppData = Companion;
        colours = ["companion1", "companion2", "companion3"];
        break;
      case "https://staging.learnaboutrescue.com/resources":
        AppData = Companion;
        colours = ["companion1", "companion2", "companion3"];
        break;
      case "https://www.viroxfarmanimal.com/resources/ahp-compatibility":
        AppData = Farm;
        colours = ["farm1", "farm2", "farm3"];
        break;
      case "https://www.viroxanimalhealth.com/ahp-compatibility":
        AppData = Animal;
        break;
      case "https://www.viroxprobeauty.com/compatibility":
        AppData = ProBeautyUs;
        colours = ["beautyUS1", "beautyUS2", "beautyUS3"];
        break;
      case "https://www.viroxprobeauty.ca/compatibility":
        AppData = ProBeautyCan;
        colours = ["beautyCan1", "beautyCan2", "beautyCan3"];
        break;
      case "https://shyield.ca/compatibility":
        AppData = Cannabis;
        colours = ["cannabis1", "cannabis2"];
        break;
      case "https://www.peroxigard.com/ahp-compatibility":
        AppData = PeroxUS;
        colours = ["perox1", "perox2"];
        break;
      default:
        break;
    }

    this.setState({
      data: AppData,
      loading: true,
      colours: colours
    });
    // axios
    //   .get(url)
    //   .then(res => {
    //     this.setState({ data: AppData, loading: true, colours: colours });
    //   })
    //   .catch(error => {
    //     console.log(error);
    //     this.setState({ loading: false });
    //   });
  }

  render() {
    const { loading, data, colours } = this.state;

    const AppData = data;
    let hasNoData = loading;
    if (AppData.length > 0) {
      hasNoData = false;
    }

    var uniqueArray = function(arrArg) {
      return arrArg.filter(function(elem, pos, arr) {
        return arr.indexOf(elem) === pos;
      });
    };

    //Tabs
    let tabs = [];
    let webCategories = [];
    let appFilteredData = [{}];
    let appColumns = [];
    let table;
    AppData.map((el, index) => {
      const { WebCategory } = el;
      webCategories.push(WebCategory);
      return null;
    });

    webCategories = uniqueArray(webCategories).sort();
    webCategories.map((el, index) => {
      let color;
      switch (index) {
        case 0:
          color = colours[0];
          break;
        case 1:
          color = colours[1];
          break;
        case 2:
          color = colours[2];
          break;
        default:
          color = colours[0];
          break;
      }
      appFilteredData = AppData.filter(key => key.WebCategory === el);
      //   let tablePages = Math.ceil(appFilteredData.length / 10);
      const ReducedAppData = _.omit(appFilteredData[0], ["WebCategory"]);
      if (ReducedAppData) {
        appColumns = Object.keys(ReducedAppData).map(key => {
          let keyToBeUsed = key;
          let width;
          switch (key) {
            case "ModelName":
              keyToBeUsed = "Model Name";
              break;
            case "ItemDescription":
              keyToBeUsed = "Item Description";
              break;
            case "ModelNumber":
              keyToBeUsed = "Model Number";
              break;
            case "Rating":
              width = 105;
              break;
            default:
              keyToBeUsed = key;
          }
          return {
            Header: keyToBeUsed,
            id: key,
            accessor: key,
            width: width,
            style: {
              whiteSpace: "unset"
            },
            Filter: ({ filter, onChange }) => (
              <input
                type="text"
                placeholder={`Filter ${keyToBeUsed}`}
                value={filter ? filter.value : ""}
                style={{
                  width: "100%"
                }}
                onChange={event => onChange(event.target.value)}
              />
            ),
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [key]
              }),
            filterAll: true
          };
        });
      }
      table = (
        <div>
          <span className="mobile-tip">
            <em> Please scroll horizontally to see more </em>{" "}
          </span>{" "}
          <ReactTable
            columns={appColumns}
            data={appFilteredData}
            loading={hasNoData} // Display the loading overlay when we need it
            filterable
            defaultPageSize={10}
            showPageSizeOptions={false}
            resizable={false}
            className="-striped -highlight"
          />
        </div>
      );
      tabs.push({
        title: el,
        content: table,
        color: color
      });
      return null;
    });

    function getTabs() {
      return tabs.map((tab, index) => ({
        title: tab.title,
        getContent: () => tab.content,
        /* Optional parameters */
        key: index,
        tabClassName: `tab ${tab.color}`,
        panelClassName: "panel"
      }));
    }

    return (
      <div>
        <Tabs
          transformWidth={720}
          showMore={false}
          items={getTabs()}
          showInkBar={false}
        />{" "}
        <br />
        <Tips />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js